module.exports = __webpack_public_path__ + "img/like-green.d6700fa1.svg";